var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'align-self-end': true,
    'risk-score-change': true,
    'text-success': _vm.change * (_vm.invert ? -1 : 1) >= 0,
    'text-danger': _vm.change * (_vm.invert ? -1 : 1) < 0,
    'small': _vm.small,
  }},[(_vm.change < 0)?_c('span',{staticClass:"material-icons-outlined"},[_vm._v(" south_east ")]):_vm._e(),(_vm.change >= 0)?_c('span',{staticClass:"material-icons-outlined"},[_vm._v(" north_east ")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.change > 0 ? "+" : "")+_vm._s(Math.round(_vm.change))+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }